export const DEFAULT_DEBUG_OPTIONS: DebugOptions = {
  jsonIncludeChildren: false,
}

export default interface DebugOptions {
  jsonIncludeChildren: boolean
}
